import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=6b66f6c6&scoped=true"
import script from "./visits-table.js?vue&type=script&lang=js&external"
export * from "./visits-table.js?vue&type=script&lang=js&external"
import style0 from "./visits-table.scss?vue&type=style&index=0&id=6b66f6c6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b66f6c6",
  null
  
)

export default component.exports